module.exports = __webpack_public_path__ + "img/wz-8-3-4.32297ae7.jpg";